import React from 'react'
import { StarsSection, TrialWithDemoButtons } from 'newComponents'
import './styles.scss'

const HeroWithCtas = ({ category, title, subtitle, sectionClassname, subtitleClassName, starsBackgroundImage }) => {
  const content = (
    <div className="container content">
      <p className="overline-title">{category}</p>
      <h1 className="title">{title}</h1>
      <p className={subtitleClassName || 'text-large'}>{subtitle}</p>
      <TrialWithDemoButtons />
    </div>
  )

  return (
    <>
      {starsBackgroundImage ? (
        <StarsSection className="hero-with-ctas section is-xlarge bg-dark " stars={starsBackgroundImage}>
          {content}
        </StarsSection>
      ) : (
        <section className={`hero-with-ctas section is-xlarge ${sectionClassname || 'bg-gradient-reverse'}`}>
          {content}
        </section>
      )}
    </>
  )
}

export default HeroWithCtas
